require('core-js/stable')
require('regenerator-runtime/runtime')
require('intersection-observer')
require('css-element-queries').ElementQueries.listen()
